module.exports = __webpack_public_path__ + "static/media/ankitvaria.06b2b991.jpeg";